import { render } from "./normall.vue?vue&type=template&id=ae87996a"
import script from "./normall.vue?vue&type=script&lang=js"
export * from "./normall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__